export { default } from './stylist-list.view';
